module.exports = __webpack_public_path__ + "static/media/custom_document.6dced157.svg";